import * as types from './types';

export const open = ({ commit }, modal) => {
  document.body.className = 'c-modal-open';

  if (modal.params && modal.name) {
    return commit(types.OPEN_CUSTOM_MODAL, modal);
  }
  return commit(types.OPEN_MODAL, modal);
};

export const close = ({ commit }) => {
  document.body.className = '';
  commit(types.CLOSE_MODAL);
};




// WEBPACK FOOTER //
// ./src/shared/components/modal/store/actions.js